// useProjectData.js
// Phase 6: Centralized data state for ProjectDetail
// Returns data state and setters - fetching logic stays in ProjectDetail for now

import { useState } from 'react';

export const useProjectData = () => {
  // Core project state
  const [project, setProject] = useState(null);
  const [loading, setLoading] = useState(true);
  const [accessDenied, setAccessDenied] = useState(false);
  const [csiItems, setCsiItems] = useState([]);
  
  // Window data
  const [windowTypes, setWindowTypes] = useState([]);
  const [windowGlassTypes, setWindowGlassTypes] = useState([]);
  const [windowMetalPanelTypes, setWindowMetalPanelTypes] = useState([]);
  const [windowList, setWindowList] = useState([]);
  
  // Curtain Wall data
  const [curtainwallTypes, setCurtainwallTypes] = useState([]);
  const [glassTypes, setGlassTypes] = useState([]);
  const [metalPanelTypes, setMetalPanelTypes] = useState([]);
  const [panelList, setPanelList] = useState([]);
  
  // Storefront data
  const [storefrontTypes, setStorefrontTypes] = useState([]);
  const [storefrontGlassTypes, setStorefrontGlassTypes] = useState([]);
  const [storefrontMetalPanelTypes, setStorefrontMetalPanelTypes] = useState([]);
  const [storefrontPanelList, setStorefrontPanelList] = useState([]);
  
  // Door data
  const [doorTypes, setDoorTypes] = useState([]);
  const [doorGlassTypes, setDoorGlassTypes] = useState([]);
  const [doorMetalPanelTypes, setDoorMetalPanelTypes] = useState([]);
  const [doorHardwareSets, setDoorHardwareSets] = useState([]);
  const [doorSchedules, setDoorSchedules] = useState([]);
  
  // Mirror data (08 00 01)
  const [mirrorTypes, setMirrorTypes] = useState([]);
  const [mirrorSchedules, setMirrorSchedules] = useState([]);
  const [mirrorElevations, setMirrorElevations] = useState([]);
  
  // Shower data (08 00 02)
  const [showerTypes, setShowerTypes] = useState([]);
  const [showerGlassTypes, setShowerGlassTypes] = useState([]);
  const [showerHardwareSets, setShowerHardwareSets] = useState([]);
  const [showerSchedules, setShowerSchedules] = useState([]);
  const [showerElevations, setShowerElevations] = useState([]);
  
  // Elevations
  const [elevations, setElevations] = useState([]);
  const [windowElevations, setWindowElevations] = useState([]);
  const [curtainwallElevations, setCurtainwallElevations] = useState([]);
  const [storefrontElevations, setStorefrontElevations] = useState([]);
  const [doorElevations, setDoorElevations] = useState([]);
  
  // Submittals
  const [submittals, setSubmittals] = useState([]);
  
  // Glass specs
  const [glassTypeSpecs, setGlassTypeSpecs] = useState([]);

  return {
    // Core state
    project, setProject,
    loading, setLoading,
    accessDenied, setAccessDenied,
    csiItems, setCsiItems,
    
    // Window data
    windowTypes, setWindowTypes,
    windowGlassTypes, setWindowGlassTypes,
    windowMetalPanelTypes, setWindowMetalPanelTypes,
    windowList, setWindowList,
    
    // Curtain Wall data
    curtainwallTypes, setCurtainwallTypes,
    glassTypes, setGlassTypes,
    metalPanelTypes, setMetalPanelTypes,
    panelList, setPanelList,
    
    // Storefront data
    storefrontTypes, setStorefrontTypes,
    storefrontGlassTypes, setStorefrontGlassTypes,
    storefrontMetalPanelTypes, setStorefrontMetalPanelTypes,
    storefrontPanelList, setStorefrontPanelList,
    
    // Door data
    doorTypes, setDoorTypes,
    doorGlassTypes, setDoorGlassTypes,
    doorMetalPanelTypes, setDoorMetalPanelTypes,
    doorHardwareSets, setDoorHardwareSets,
    doorSchedules, setDoorSchedules,
    
    // Mirror data (08 00 01)
    mirrorTypes, setMirrorTypes,
    mirrorSchedules, setMirrorSchedules,
    mirrorElevations, setMirrorElevations,
    
    // Shower data (08 00 02)
    showerTypes, setShowerTypes,
    showerGlassTypes, setShowerGlassTypes,
    showerHardwareSets, setShowerHardwareSets,
    showerSchedules, setShowerSchedules,
    showerElevations, setShowerElevations,
    
    // Elevations
    elevations, setElevations,
    windowElevations, setWindowElevations,
    curtainwallElevations, setCurtainwallElevations,
    storefrontElevations, setStorefrontElevations,
    doorElevations, setDoorElevations,
    
    // Submittals
    submittals, setSubmittals,
    
    // Glass specs
    glassTypeSpecs, setGlassTypeSpecs
  };
};

export default useProjectData;
